export const latLngBounds = {
	lat: { max: 90, min: -90 },
	lng: { max: 180, min: -180 }
};
